import React from 'react';
import ReactDOM from 'react-dom/client';

const enableMocking = async () => {
  if (process.env.NODE_ENV !== 'development') return;
  const { worker } = await import('__tests__/api/mocks/browser');
  await worker.start();
};

const importBuildTarget = async () => {
  try {
    switch (process.env.REACT_APP_BUILD_TARGET) {
      case 'SCC_ADMIN': {
        const { App } = await import('./sccAdmin/App');
        return App;
      }
      case 'COMPANY_ADMIN': {
        const { App } = await import('./companyAdmin/App');
        return App;
      }
      case 'SALES': {
        const { App } = await import('./sales/App');
        return App;
      }
      default:
        throw new Error(`No such build target: ${process.env.REACT_APP_BUILD_TARGET}`);
    }
  } catch (error) {
    console.error('�A�v���̃r���h�Ώۓǂݍ��ݒ��ɃG���[���������܂���:', error);
    throw error; // �Ăяo������ catch
  }
};

const startApp = async () => {
  try {
    await enableMocking();
    const App = await importBuildTarget();

    if (!App) throw new Error('App ���ǂݍ��߂܂���ł���');

    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (err) {
    console.error('�A�v���N�����̒v���I�G���[:', err);

    // fallback �\���Ȃǁi�C�Ӂj
    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
    root.render(
      <div style={{ padding: 40, textAlign: 'center', color: 'red' }}>
        �A�v���̋N���Ɏ��s���܂����B�y�[�W���ēǂݍ��݂��Ă��������B
      </div>
    );
  }
};

startApp();
